import { MapContainer, Marker, Circle, Polygon, Polyline, Tooltip } from "react-leaflet";
import { Tiles, dot, MapClicks, FlyTo, BR_CENTER, latlngOf } from "./mapParts";
import { brl } from "@/lib/api";

const RADIUS_STYLE = { color: "#64748b", weight: 1.5, dashArray: "6 6", fillOpacity: 0.04 };
const info = (z) => `${brl(Number(z.fee) || 0)}${Number(z.eta) > 0 ? ` · ${z.eta} min` : ""}`;

export function ZoneLayers({ center, radii, areas, editing = null }) {
  return (<>
    {center && radii.filter((r) => Number(r.km) > 0).map((r, i) => (
      <Circle key={`r${i}`} center={center} radius={Number(r.km) * 1000} pathOptions={RADIUS_STYLE}>
        <Tooltip sticky>Até {r.km} km · {info(r)}</Tooltip>
      </Circle>
    ))}
    {areas.map((a, i) => (a.points.length >= 3 ? (
      <Polygon key={`a${i}`} positions={a.points} pathOptions={{ color: a.color, weight: editing === i ? 3 : 2, fillOpacity: 0.18 }}>
        <Tooltip sticky>{a.name} · {info(a)}</Tooltip>
      </Polygon>
    ) : <Polyline key={`a${i}`} positions={a.points} pathOptions={{ color: a.color, dashArray: "4 4" }} />))}
  </>);
}

export function DeliveryMapEditor({ store, radii, areas, editing, focus, onStore, onAddPoint, onMovePoint }) {
  const has = store?.lat != null;
  const center = has ? [store.lat, store.lng] : BR_CENTER;
  const click = (p) => (editing != null ? onAddPoint(p) : !has && onStore(p));
  return (
    <div className="isolate overflow-hidden rounded-lg border" data-testid="delivery-map-editor">
      <MapContainer center={center} zoom={has ? 13 : 4} className={`h-[420px] w-full ${editing != null ? "cursor-crosshair" : ""}`}>
        <Tiles />
        <FlyTo point={focus} zoom={15} />
        <MapClicks onClick={click} />
        <ZoneLayers center={has ? center : null} radii={radii} areas={areas} editing={editing} />
        {editing != null && areas[editing]?.points.map((p, j) => (
          <Marker key={`v${j}`} position={p} icon={dot(areas[editing].color, 14)} draggable eventHandlers={{ dragend: (e) => onMovePoint(j, latlngOf(e)) }} />
        ))}
        {has && (
          <Marker position={center} icon={dot("#0f172a", 22)} draggable eventHandlers={{ dragend: (e) => onStore(latlngOf(e)) }}>
            <Tooltip direction="top">Sua loja (arraste para ajustar)</Tooltip>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
}
